import React, { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import { auth } from "../../firebase/firebase.utils";
import { handleGetFirebaseUid } from "../../redux/Auth/action";
import { useDispatch } from "react-redux";
import GlobalLoader from "../v3/components/Common/GlobalLoader";
import AppDownloadQRModal from "../v3/components/Common/AppDownloadQRModal";
import useStore from "../../store/UseStore";

const BaseLayout = ({ children, className }) => {
  const { openQRModal } = useStore();
  const dispatch = useDispatch();

  // Generates default firebaseUID and stores in redux-store.
  const handleLoadUser = async () => {
    let token = null;
    let storedUser = null;
    try {
      token = localStorage.getItem("token");
      storedUser = JSON.parse(localStorage.getItem("currentUser"));
    } catch (error) {
      console.error("Error accessing localStorage:", error);
    }
    let user = { accessToken: token, uid: storedUser?.uid };
    if (!token || !storedUser) {
      try {
        const data = await auth.signInAnonymously();
        user = {
          accessToken: (await data.user?.getIdTokenResult()).token,
          uid: data.user.uid,
        };
      } catch (authError) {
        console.error("Error during anonymous sign-in:", authError);
      }
    }
    dispatch(handleGetFirebaseUid(user?.uid));
  };

  useEffect(() => {
    handleLoadUser();
  }, []);
  return (
    <div>
      <div className={` bg-black ${className || ""}`}>{children}</div>
      <GlobalLoader />
      {openQRModal && <AppDownloadQRModal />}
      <ToastContainer
        position="bottom-left"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
      />
    </div>
  );
};

export default BaseLayout;
